// @ts-check
import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { getTransactionDetails } from ".";

export default function useGetTransactionById(invoiceId) {
  const { sessionJWT } = useSessionJWT();

  const fetchTransactionDetails = useCallback(() => {
    return getTransactionDetails(sessionJWT, invoiceId);
  }, [sessionJWT, invoiceId]);

  return useQuery({
    queryKey: ["transactions", "details", invoiceId],
    queryFn: fetchTransactionDetails,
    refetchOnMount: false, // TODO: When this endpoint has been optimized, remove this
  });
}
